import { fontWeightClassName, fontWeights } from '@va/ui/design-system';
import classNames from 'classnames';
import { PropsWithChildren, Ref, forwardRef } from 'react';
import { getTypographyClassNames } from './helpers';
import { HeadingProps, TypographyProps, TypographyVariants } from './types';

export const Heading3 = forwardRef(
  <T extends keyof TypographyVariants>(
    {
      weight = fontWeights.normal,
      colorClassName = 'text-text-dark',
      className,
      variant,
      variantSize,
      children,
      ...rest
    }: PropsWithChildren<HeadingProps & TypographyProps<T>>,
    ref: Ref<HTMLHeadingElement>,
  ) => {
    const typographyClasses = getTypographyClassNames({ variant, variantSize });

    const classes = classNames(
      'font-primary',
      {
        'sm-initial:text-3xl sm-initial:leading-36 sm-initial:-tracking-0024 text-21 leading-30 -tracking-0021':
          !typographyClasses,
        [typographyClasses]: !!typographyClasses,
      },
      fontWeightClassName(weight),
      colorClassName,
      className,
    );

    return (
      <h3 ref={ref} className={classes} {...rest}>
        {children}
      </h3>
    );
  },
);
